import React, { useState } from 'react';
import classes from './NewSignup.module.css';
import Background from '../../Asset/Background.png';
import logonew from '../../Asset/logonew.png';
import newtwo from '../../Asset/imgs2.jpg';
import dot from '../../Asset/Background.png';
import { Form, Button, Spinner,Modal, Toast, ToastContainer  } from "react-bootstrap";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { useNavigate, Link } from 'react-router-dom';
import Swal from "sweetalert2";
import axios from "axios";
import { BASE_URL } from "../../API/Api";
import crossedEyeIcon from '../../Asset/crossedEyeIcon.svg';
import Firstname from "../../Asset/Icon Left.png"
import EmailIcon from "../../Asset/Icon Left (2).png";
import PhoneIcon from "../../Asset/Icon Left (1).png";
import LockIcon from "../../Asset/Icon Left (3).png";
import ChatIcon from "../../Asset/Duotone.png";
import TickIcon from "../../Asset/tick-circle.png";

const NewSignup = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [passwordValue, setPasswordValue] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [confirmPasswordValue, setConfirmPasswordValue] = useState('');
    const [firstName, setFirstname] = useState('');
    const [secondName, setSecondName] = useState('');
    const [email, setEmail] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [codeVerify, setCodeVerify] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [checkedBox, setCheckedBox] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingScreen, setLoadingScreen] = useState(false);
    const [loadForm, setLoadForm] = useState(true);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessages, setErrorMessages] = useState("");

    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [customerType, setCustomerType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [accountNumber, setAccountNumber] = useState('');
  const [accountDetails, setAccountDetails] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const handleRadioChange = (event) => {
    const value = event.target.value;
    
    setSelectedCustomer(value);
    setCustomerType(value);
    console.log(customerType, 'new customer type');
    if (value === 'existing') {
      setShowModal(true);
    }
    if (value === 'new') {
    //   setShowModal(true);
    setLoadingScreen(true);
    setLoadForm(false);
    }
  };

  const handleModalClose = () => setShowModal(false);

  const fetchAccount = async () => {
    setLoadingScreen(false);
    setLoadForm(true);
    Swal.fire({
        title: 'Fetching Account...',
        text: 'Please wait while we retrieve your account details.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

    try {
      const response = await axios.get(`${BASE_URL}/fetch_customer_by_account`, {
        params: {
          account_number: accountNumber,
        },
       
      });
    //   setShowForm(true);
    //   setSelectedCustomer("new");
    //   setCustomerType("existing");
      const results = response.data.data[0] || '';
      setAccountDetails(results);
      setFirstname(results.first_name || '');
      setSecondName(results.last_name || '');
      setPhoneNumber(results.phone || '');
      setEmail(results.email || '');
      
      Swal.close();
      setLoadingScreen(true);
      setLoadForm(false);
    } catch (error) {
      setLoadingScreen(false);
      setLoadForm(true);
      console.error(error.response.data.message.account_number[0] || "Error fetching data");
      setErrorMessages(error.response.data.message.account_number[0]);
      setShowErrorToast(true);
      Swal.close();
    }
  };

  const handleAccountSubmit = (e) => {
    e.preventDefault();
    fetchAccount();
    setShowModal(false);

  };

 

//   const handleNewCustomerChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleNewCustomerSubmit = (e) => {
//     e.preventDefault();
//     console.log('New Customer Data:', formData);
//   };



    const [passwordValidations, setPasswordValidations] = useState({
        length: false,
        uppercase: false,
        lowercase: false,
        specialChar: false,
        match: false,
        number: false
    });
    const [showValidations, setShowValidations] = useState(false);
    const [fieldErrors, setFieldErrors] = useState({
        firstName: false,
        lastName: false,
        email: false,
        phone: false,
        password: false,
        confirmPassword: false
    });

    const showSwal = (message, onResend, onOk) => {
        Swal.fire({
            imageUrl: TickIcon,
            imageWidth: 48,
            imageHeight: 48,
            title: "Success!",
            text: message,
            showCancelButton: true,
            cancelButtonText: "Click here to resend link",
            confirmButtonText: "Okay",
            customClass: {
                title: classes.myTitle,
                popup: classes.myText,
                confirmButton: classes.myDeclineButton,
                cancelButton: classes.myCancelButton,
            },
            allowOutsideClick: false,
        }).then(async (result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                try {
                    // const resendMsg = await handleResendOtp();
                    showSwal(true, onOk); // recursive call with same logic
                } catch (resendError) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: resendError.message,
                    });
                }
            } else if (result.isConfirmed && onOk) {
                onOk(); // Navigate to login
            }
        });
    };

    const toggleConfirmPassword = () => {
        setShowConfirmPassword(prev => !prev);
    };

    // const handleConfirmPasswordChange = (e) => {
    //   setConfirmPasswordValue(e.target.value);
    // };

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };

    // const handlePasswordChange = (e) => {
    //   setPasswordValue(e.target.value);
    // };

    const [showResend, setShowResend] = useState(false);
    const [validateLoading, setValidateLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);

    const handleOtp = async () => {
        setValidateLoading(true);
        setShowErrorMessage(false);

        try {
            const response = await axios.post(`${BASE_URL}/sign-up`, {
                first_name: firstName,
                last_name: secondName,
                email: email
            });
            setShowResend(true);
            Swal.fire({
                icon: "success",
                title: "Success!",
                text: response.data.message,
            });

            // showSwal(response.data.message, true, () => {
            //   setFirstname('');
            //   setSecondName('');
            //   setEmail('');
            // });


        } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            const newFieldErrors = {
                firstName: false,
                secondName: false,
                email: false,
            };

            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                const errorMessages = []; // Array to collect all error messages

                // Handle string error messages
                if (typeof msg === 'string') {
                    errorMessages.push(msg);

                    // Check for field-specific errors in the message
                    if (msg.toLowerCase().includes('first name') || msg.toLowerCase().includes('first_name')) {
                        newFieldErrors.firstName = true;
                    }
                    if (msg.toLowerCase().includes('last name') || msg.toLowerCase().includes('last_name')) {
                        newFieldErrors.secondName = true;
                    }
                    if (msg.toLowerCase().includes('email')) {
                        newFieldErrors.email = true;
                    }
                }
                // Handle array error messages
                else if (Array.isArray(msg)) {
                    msg.forEach(message => {
                        if (typeof message === 'string') {
                            errorMessages.push(message);

                            if (message.toLowerCase().includes('first name') || message.toLowerCase().includes('first_name')) {
                                newFieldErrors.firstName = true;
                            }
                            if (message.toLowerCase().includes('last name') || message.toLowerCase().includes('last_name')) {
                                newFieldErrors.secondName = true;
                            }
                            if (message.toLowerCase().includes('email')) {
                                newFieldErrors.email = true;
                            }
                        }
                    });
                }
                // Handle object error messages (Laravel-style validation errors)
                else if (typeof msg === 'object') {
                    Object.entries(msg).forEach(([key, messages]) => {
                        const fieldName = key.toLowerCase();

                        if (fieldName.includes('first_name') || fieldName.includes('first name')) {
                            newFieldErrors.firstName = true;
                        } else if (fieldName.includes('last_name') || fieldName.includes('last name')) {
                            newFieldErrors.secondName = true;
                        } else if (fieldName.includes('email')) {
                            newFieldErrors.email = true;
                        }

                        if (Array.isArray(messages)) {
                            errorMessages.push(...messages);
                        } else if (typeof messages === 'string') {
                            errorMessages.push(messages);
                        }
                    });
                }

                // Join all error messages with commas
                errorMessage = errorMessages.join(', ');
                Swal.fire({
                    icon: "error",
                    title: "Failed!",
                    text: errorMessages,
                });
            }

            setFieldErrors(newFieldErrors);
            setErrorMessage(errorMessage);
            setShowErrorMessage(true);
            setShowResend(false);

        } finally {
            setValidateLoading(false);
        }

    }
    const ResendhandleOtp = async () => {
        setResendLoading(true);
        setShowErrorMessage(false);

        try {
            const response = await axios.post(`${BASE_URL}/sign-up`, {
                first_name: firstName,
                last_name: secondName,
                email: email
            });
            setShowResend(true);
            Swal.fire({
                icon: "success",
                title: "Success!",
                text: response.data.message,
            });

            // showSwal(response.data.message, true, () => {
            //   setFirstname('');
            //   setSecondName('');
            //   setEmail('');
            // });


        } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            const newFieldErrors = {
                firstName: false,
                secondName: false,
                email: false,
            };

            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                const errorMessages = []; // Array to collect all error messages

                // Handle string error messages
                if (typeof msg === 'string') {
                    errorMessages.push(msg);

                    // Check for field-specific errors in the message
                    if (msg.toLowerCase().includes('first name') || msg.toLowerCase().includes('first_name')) {
                        newFieldErrors.firstName = true;
                    }
                    if (msg.toLowerCase().includes('last name') || msg.toLowerCase().includes('last_name')) {
                        newFieldErrors.secondName = true;
                    }
                    if (msg.toLowerCase().includes('email')) {
                        newFieldErrors.email = true;
                    }
                }
                // Handle array error messages
                else if (Array.isArray(msg)) {
                    msg.forEach(message => {
                        if (typeof message === 'string') {
                            errorMessages.push(message);

                            if (message.toLowerCase().includes('first name') || message.toLowerCase().includes('first_name')) {
                                newFieldErrors.firstName = true;
                            }
                            if (message.toLowerCase().includes('last name') || message.toLowerCase().includes('last_name')) {
                                newFieldErrors.secondName = true;
                            }
                            if (message.toLowerCase().includes('email')) {
                                newFieldErrors.email = true;
                            }
                        }
                    });
                }
                // Handle object error messages (Laravel-style validation errors)
                else if (typeof msg === 'object') {
                    Object.entries(msg).forEach(([key, messages]) => {
                        const fieldName = key.toLowerCase();

                        if (fieldName.includes('first_name') || fieldName.includes('first name')) {
                            newFieldErrors.firstName = true;
                        } else if (fieldName.includes('last_name') || fieldName.includes('last name')) {
                            newFieldErrors.secondName = true;
                        } else if (fieldName.includes('email')) {
                            newFieldErrors.email = true;
                        }

                        if (Array.isArray(messages)) {
                            errorMessages.push(...messages);
                        } else if (typeof messages === 'string') {
                            errorMessages.push(messages);
                        }
                    });
                }

                // Join all error messages with commas
                errorMessage = errorMessages.join(', ');
                Swal.fire({
                    icon: "error",
                    title: "Failed!",
                    text: errorMessages,
                });
            }

            setFieldErrors(newFieldErrors);
            setErrorMessage(errorMessage);
            setShowErrorMessage(true);
            setShowResend(false);

        } finally {
            setResendLoading(false);
        }

    }
    console.log(selectedCustomer, "customertype");
    const verifyDisabled = !firstName || !secondName || !email || loading

    const accountUpdate = firstName || secondName || email || phoneNumber
    const handleSignup = async () => {
        setLoading(true);
        setShowErrorMessage(false);

        
        if (passwordValue !== confirmPasswordValue) {
            setErrorMessage("Password and Confirm Password do not match.");
            setShowErrorMessage(true);
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/validate-user`, {
                otp: codeVerify,
                email: email,
                phone: phoneNumber,
                password: passwordValue,
                registration_type: customerType,
                confirm_password: confirmPasswordValue
            });
            
            navigate('/login');
            Swal.fire({
                icon: "success",
                title: "Success!",
                text: response.data.message,
            });
           
              setFirstname('');
              setSecondName('');
              setEmail('');
              setPhoneNumber('');
              setPasswordValue('');
              setConfirmPasswordValue('');
              setCustomerType('');
          

        } catch (error) {
            let errorMessage = 'An error occurred. Please try again.';
            const newFieldErrors = {
                firstname: false,
                secondName: false,
                email: false,
                phoneNumber: false,
                passwordValue: false,
                confirmPasswordValue: false
            };

            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                const errorMessages = []; // Array to collect all error messages

                // Handle string error messages
                if (typeof msg === 'string') {
                    errorMessages.push(msg);

                    // Check for field-specific errors in the message
                    if (msg.toLowerCase().includes('first name') || msg.toLowerCase().includes('first_name')) {
                        newFieldErrors.firstname = true;
                    }
                    if (msg.toLowerCase().includes('last name') || msg.toLowerCase().includes('last_name')) {
                        newFieldErrors.secondName = true;
                    }
                    if (msg.toLowerCase().includes('email')) {
                        newFieldErrors.email = true;
                    }
                    if (msg.toLowerCase().includes('phone')) {
                        newFieldErrors.phoneNumber = true;
                    }
                    if (msg.toLowerCase().includes('password')) {
                        newFieldErrors.passwordValue = true;
                    }
                    if (msg.toLowerCase().includes('confirm password') || msg.toLowerCase().includes('confirm_password')) {
                        newFieldErrors.confirmPasswordValue = true;
                    }
                }
                // Handle array error messages
                else if (Array.isArray(msg)) {
                    msg.forEach(message => {
                        if (typeof message === 'string') {
                            errorMessages.push(message);

                            if (message.toLowerCase().includes('first name') || message.toLowerCase().includes('first_name')) {
                                newFieldErrors.firstname = true;
                            }
                            if (message.toLowerCase().includes('last name') || message.toLowerCase().includes('last_name')) {
                                newFieldErrors.secondName = true;
                            }
                            if (message.toLowerCase().includes('email')) {
                                newFieldErrors.email = true;
                            }
                            if (message.toLowerCase().includes('phone')) {
                                newFieldErrors.phoneNumber = true;
                            }
                            if (message.toLowerCase().includes('password')) {
                                newFieldErrors.passwordValue = true;
                            }
                            if (message.toLowerCase().includes('confirm password') || message.toLowerCase().includes('confirm_password')) {
                                newFieldErrors.confirmPasswordValue = true;
                            }
                        }
                    });
                }
                // Handle object error messages (Laravel-style validation errors)
                else if (typeof msg === 'object') {
                    Object.entries(msg).forEach(([key, messages]) => {
                        const fieldName = key.toLowerCase();

                        if (fieldName.includes('first_name') || fieldName.includes('first name')) {
                            newFieldErrors.firstname = true;
                        } else if (fieldName.includes('last_name') || fieldName.includes('last name')) {
                            newFieldErrors.secondName = true;
                        } else if (fieldName.includes('email')) {
                            newFieldErrors.email = true;
                        } else if (fieldName.includes('phone')) {
                            newFieldErrors.phoneNumber = true;
                        } else if (fieldName.includes('password')) {
                            newFieldErrors.passwordValue = true;
                        } else if (fieldName.includes('confirm_password') || fieldName.includes('confirm password')) {
                            newFieldErrors.confirmPasswordValue = true;
                        }

                        if (Array.isArray(messages)) {
                            errorMessages.push(...messages);
                        } else if (typeof messages === 'string') {
                            errorMessages.push(messages);
                        }
                    });
                }

                // Join all error messages with commas
                errorMessage = errorMessages.join(', ');
                Swal.fire({
                    icon: "error",
                    title: "Failed!",
                    text: errorMessages,
                });
            }

            setFieldErrors(newFieldErrors);
            setErrorMessage(errorMessage);
            setShowErrorMessage(true);



        } finally {
            setLoading(false);
        }
    };

    const handleFirstName = (e) => {
        const value = e.target.value;
        setFirstname(value);
        setFieldErrors(prev => ({ ...prev, firstName: !value.trim() }));
        setShowErrorMessage(false);
    };

    const handleSecondName = (e) => {
        const value = e.target.value;
        setSecondName(value);
        setFieldErrors(prev => ({ ...prev, lastName: !value.trim() }));
        setShowErrorMessage(false);
    };

    const handleEmail = (e) => {
        const value = e.target.value;
        setEmail(value);
        setFieldErrors(prev => ({ ...prev, email: !value.trim() }));
        setShowErrorMessage(false);
    };

    const handlePhoneNumber = (e) => {
        const value = e.target.value;
        setPhoneNumber(value);
        setFieldErrors(prev => ({ ...prev, phone: !value.trim() }));
        setShowErrorMessage(false);
    };

    const handlePassword = (e) => {
        const value = e.target.value;
        setPasswordValue(value);
        setFieldErrors(prev => ({ ...prev, password: !value.trim() }));
        setShowErrorMessage(false);
        setShowValidations(true);
        setPasswordValidations({
            length: value.length >= 6,
            uppercase: /[A-Z]/.test(value),
            lowercase: /[a-z]/.test(value),
            specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value),
            match: confirmPasswordValue === value,
            number: /\d/.test(value),
        });
    };

    const handleConfirmPassword = (e) => {
        const value = e.target.value;
        setConfirmPasswordValue(value);
        setFieldErrors(prev => ({ ...prev, confirmPassword: !value.trim() }));
        setShowErrorMessage(false);
        setPasswordValidations((prev) => ({
            ...prev,
            match: passwordValue === value,
        }));
    };

    const textdisabled = () => {
        handleOtp();
    }

  return (
    <div className={classes.container}>
      <div className={classes.general}>
        <div className={classes.left}>
             <div className={classes.formContainer}>
            <div className={classes.top}>
              <img src={logonew} alt="" className={classes.logo} />
              <h1 className={classes.title}>Welcome!</h1>
              <p className={classes.subText}>Sign up for your OGSWC account. <br/>Already have an account? <span className={classes.textlink}><Link style={{color: '#000'}} to="/login" >Login</Link></span></p>
            </div>
          </div>
          {loadForm && (
                <Form>
                <h4 className={classes.headstat}>1. Select Your Customer Status</h4>
                <div className={classes.checkgroup}>
                    <label className={classes.remember}>
                                      <input
                                        type="checkbox"
                                        id="newCustomer"
                                        name="newCustomer"
                                        checked={customerType === 'new'}
                                        onChange={handleRadioChange}
                                        value="new"
                                        className={classes.squareCheckbox}
                                      />
                                      New Customer
                                    </label>
                    <label className={classes.remember}>
                                      <input
                                        type="checkbox"
                                        id="existingCustomer"
                                        name="existingCustomer"
                                        value="existing"
    checked={customerType === 'existing'}
    onChange={(e) => {
      handleRadioChange(e);
      if (e.target.value === 'existing') setShowModal(true);
    }}
                                        className={classes.squareCheckbox}
                                      />
                                     Existing Customer
                                    </label>
             


                </div>
             </Form>
               )}
<Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title style={{color: "rgb(10, 15, 107)"}}>Enter Account Number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form 
        //   onSubmit={handleAccountSubmit}
          >
            <Form.Group controlId="formAccountNumber">
              <Form.Label style={{color: "rgb(10, 15, 107)"}}>Account Number</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter account number"
                value={accountNumber}
                onChange={(e) => setAccountNumber(e.target.value)}
                required
              />
            </Form.Group>
            <Button onClick={handleAccountSubmit} style={{width: "100%"}} variant="primary" type="submit" className="mt-3">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
          <ToastContainer position="top-end" style={{position: "fixed", top: "0", right: '0', zIndex: '2'}} className="p-3">

        <Toast 
            bg="danger" 
            onClose={() => setShowErrorToast(false)} 
            show={showErrorToast} 
            delay={3000} 
            autohide
            style={{ maxWidth: '300px'}}
            >
            <Toast.Header>
            <strong style={{ fontWeight: '900'}} className="me-auto text-white">Error</strong>
            </Toast.Header>
            <Toast.Body  className="text-white">{errorMessages}</Toast.Body>
        </Toast>
    </ToastContainer>
    {loadingScreen && (
                 <div className={classes.formsection}>
                                     <Form> 
                                        <div 
    
                                    > 
                                    <div className={
                                        classes.formgroup
                                    }
    
                                    > {
                                                /* <div className={classes.sendcode1}> */
                                            }
    
                                            <div style={
                                                {
                                                    position: "relative"
                                                }
                                            }
    
                                            > <img src={
                                                Firstname
                                            }
    
                                                className={
                                                    classes.firsname
                                                }
    
                                                style={
                                                    {
                                                        position: 'absolute',
                                                        left: '1%',
                                                        top: '28%',
                                                        //   transform: 'translateY(-50%)',
                                                        zIndex: 2
                                                    }
                                                }
    
                                                alt="firstname" /> <input type="text" className={
                                                    classes.Firstname
                                                }
    
                                                    style={
                                                        {
                                                            width: '270px'
                                                        }
                                                    }
    
                                                    placeholder="First Name" required 
                                                    value={firstName}
    
                                                    onChange={
                                                        handleFirstName
                                                    }
    
                                                /> </div> 
                                                <div style={
                                                    {
                                                        position: "relative"
                                                    }
                                                }
    
                                                > <img src={
                                                    Firstname
                                                }
    
                                                    className={
                                                        classes.firsname
                                                    }
    
                                                    style={
                                                        {
                                                            float: "left",
                                                            cursor: 'pointer',
                                                            position: 'absolute',
                                                            left: '1%',
                                                            top: '28%',
                                                            //   transform: 'translateY(-50%)',
                                                            zIndex: 2
                                                        }
                                                    }
    
                                                    alt="firstname" /> <input type="text" style={
                                                        {
                                                            paddingRight: '30px',
                                                            width: '270px',
                                                            boxSizing: 'border-box'
                                                        }
                                                    }
    
                                                        className={
                                                            classes.lastname
                                                        }
    
                                                        value={
                                                            secondName
                                                        }
    
                                                        onChange={
                                                            handleSecondName
                                                        }
    
                                                        placeholder="Last Name" required /> </div> {
                                                /* </div> */
                                            }
    
                                        </div> 

 <div className={
                                        classes.formgroup
                                    }
    
                                    > 
                                        <div style={
                                            {
                                                position: "relative"
                                            }
                                        }
    
                                        > <img src={
                                            EmailIcon
                                        }
    
                                            className={
                                                classes.firsname
                                            }
    
                                            style={
                                                {
                                                    position: 'absolute',
                                                    left: '1%',
                                                    top: '19%',
                                                    //   transform: 'translateY(-50%)',
                                                    zIndex: 2
                                                }
                                            }
    
                                            alt="Email" /> <input type="email"
    
                                                className={
                                                    classes.email
                                                }
    
                                                placeholder="Email" required style={
                                                    {
                                                         width: "270px"
                                                    }
                                                }
    
                                                value={
                                                    email
                                                }
    
                                                onChange={
                                                    handleEmail
                                                }
    
                                            /> </div> 
                                            <div style={
                                                {
                                                     position: "relative"
                                                }
                                            }
    
                                                className={
                                                    classes.sendcode
                                                }
    
                                            > <Button variant="secondary" disabled={
                                                verifyDisabled
                                            }
    
                                                className={
                                                    classes.realbtn
                                                }
    
                                                style={
                                                    {
                                                        position: 'absolute',
                                                        left: '2%',
                                                        float: "left",
                                                        top: '6%',
                                                        zIndex: 2
                                                    }
                                                }
    
                                                type="button"
    
                                                onClick={
                                                    handleOtp
                                                }
    
                                            ><img src={
                                                ChatIcon
                                            }
    
                                                alt="CodeIcon" className={
                                                    classes.chaticon
                                                }
    
                                                /> <span className={
                                                    classes.btntext
                                                }
    
                                                > {
                                                        validateLoading ? "Processing...." : "Send code"
                                                    }
    
                                                </span></Button> <input type="text" className={
                                                    classes.code
                                                }
    
                                                    placeholder="Verification Code"
    
                                                    required style={
                                                        {
                                                            width: "270px"
                                                        }
                                                    }
    
                                                    value={
                                                        codeVerify
                                                    }
    
                                                    onChange={
                                                        (e) => setCodeVerify(e.target.value)
                                                    }
    
                                            /> {
                                                showResend === true ? (<p onClick={
                                                    ResendhandleOtp
                                                }
    
                                                    className={
                                                        classes.otp
                                                    }
    
                                                > {
                                                        resendLoading ? ("Resending, please wait..."
    
                                                        ) : (<>Click here to <span style={
                                                            {
                                                                color: '#000',
                                                               
                                                            }
                                                        }
    
                                                        >resend OTP</span></>)
                                                    }
    
                                                </p>) : null
                                            }
    
                                        </div> 
                                        </div> 
                                        
                                        <div style={
                                            {
                                               position: "relative"
                                            }
                                        }
    
                                        > <img src={
                                            PhoneIcon
                                        }
    
                                            className={
                                                classes.phoneno
                                            }
    
                                            style={
                                                {
                                                    float: "left",
                                                    position: 'absolute',
                                                    left: '1%',
                                                    top: '21%',
                                                    //   transform: 'translateY(-50%)',
                                                    zIndex: 2
                                                }
                                            }
    
                                            alt="Phone Number" /> <input type="tel" className={
                                                classes.phonenumber
                                            }
    
                                                placeholder="Phone Number"
    
                                                required style={
                                                    {
                                                         width: "550px",
                                                         marginTop: "-10px",
                                                         marginBottom: 10
                                                    }
                                                }
    
                                                value={
                                                    phoneNumber
                                                }
    
                                                onChange={
                                                    handlePhoneNumber
                                                }
    
                                            /> 
                                            </div> 
                                            
                                            <div className={
                                                classes.formgroup
                                            }
    
                                            > <div style={
                                                {
                                                    position: 'relative', 
                                                }
                                            }
    
                                            > <img src={
                                                LockIcon
                                            }
    
                                                className={
                                                    classes.firsname1
                                                }
    
                                                style={
                                                    {
                                                        position: 'absolute',
                                                        left: '1.5%',
                                                        top: '28.2%',
                                                        //   transform: 'translateY(-50%)',
                                                        zIndex: 2
                                                    }
                                                }
    
                                                alt="Password" /> <input type={
                                                    showPassword ? 'text' : 'password'
                                                }
    
                                                    placeholder="Password"
    
                                                    required value={
                                                        passwordValue
                                                    }
    
                                                    onChange={
                                                        handlePassword
                                                    }
    
                                                    style={
                                                        {
                                                            paddingRight: '30px',
                                                            width: '270px',
                                                            boxSizing: 'border-box'
                                                        }
                                                    }
    
                                                    className={
                                                        classes.password
                                                    }
    
                                                /> <button type="button"
                                                    onClick={
                                                        togglePassword
                                                    }
    
                                                    style={
                                                        {
                                                            background: 'none',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            zIndex: 2
                                                        }
                                                    }
    
                                                    className={
                                                        classes.Crosseye
                                                    }
    
                                                > {
                                                        showPassword ? (<img src={
                                                            crossedEyeIcon
                                                        }
    
                                                            alt="Hide Password" style={
                                                                {
                                                                    height: "17px", width: "17px"
                                                                }
                                                            }
    
                                                        />) : ('👁️'
                                                        )
                                                    }
    
                                                </button> </div> {
                                                /* <input type="password" placeholder="Confirm Password" required /> */
                                            }
    
                                            <div style={
                                                {
                                                    position: 'relative',
                                                }
                                            }
    
                                            > <img src={
                                                LockIcon
                                            }
    
                                                className={
                                                    classes.firsname1
                                                }
    
                                                style={
                                                    {
                                                        position: 'absolute',
                                                        left: '1%',
                                                        top: '28.2%',
                                                        //   transform: 'translateY(-50%)',
                                                        zIndex: 2
                                                    }
                                                }
    
                                                alt="LockIcon" /> <input type={
                                                    showConfirmPassword ? 'text' : 'password'
                                                }
    
                                                    placeholder="Confirm Password"
    
                                                    required value={
                                                        confirmPasswordValue
                                                    }
    
                                                    onChange={
                                                        handleConfirmPassword
                                                    }
    
                                                    style={
                                                        {
                                                            paddingRight: '30px',
                                                            width: '270px',
                                                            boxSizing: 'border-box'
                                                        }
                                                    }
    
                                                    className={
                                                        classes.confpassword
                                                    }
    
                                                /> <button type="button"
                                                    onClick={
                                                        toggleConfirmPassword
                                                    }
    
                                                    style={
                                                        {
                                                            background: 'none',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            position: 'absolute',
                                                            right: '10px',
                                                            top: '50%',
                                                            transform: 'translateY(-50%)',
                                                            zIndex: 2
                                                        }
                                                    }
    
                                                    className={
                                                        classes.Crosseye
                                                    }
    
                                                > {
                                                        showConfirmPassword ? (<img src={
                                                            crossedEyeIcon
                                                        }
    
                                                            alt="Hide Password" style={
                                                                {
                                                                    height: "17px", width: "17px"
                                                                }
                                                            }
    
                                                        />) : ('👁️'
                                                        )
                                                    }
    
                                                </button> </div> </div> {
                                        }
    
 <div className={classes.rememberForgot}>
                <label className={classes.remember}>
                  <input
                    type="checkbox"
                    id="agree"
                    name="agree"
                    checked={
                                            checkedBox
                                        }

                    className={classes.squareCheckbox}
                    onChange={
                                                (e) => setCheckedBox(e.target.checked)
                                            }
                  />
                  I agree to terms and conditions
                </label>

              
              </div>
                                             <Button 
                                             variant="primary"
                                             disabled={passwordValue !== confirmPasswordValue || !checkedBox}
                                             className={classes.button}
                                                onClick={() =>
                                                    handleSignup()
                                                }
    
                                                > {
                                                loading ? (<> <Spinner size='sm' /> <span style={
                                                    {
                                                        marginLeft: '5px'
                                                    }
                                                }
    
                                                >Signing up...</span> </>) : ("Continue"
                                                )
                                            }
    
                                        </Button>
                                    </div>
                            </Form>
                    </div> 
                    )}
        </div>

        <div className={classes.right}>
          <div className={classes.background}>
            <img src={newtwo} alt="Background" className={classes.heroImage} />
            <div className={classes.infoSection}>
              <h2
                style={{
                  fontSize: 30,
                  color: '#fff',
                  fontWeight: 700,
                  marginBottom: 19,
                  marginTop: -20
                }}
              >
                Reliable Water Services
              </h2>
              <div style={{ width: 500 }}>
                <p
                  style={{
                    fontSize: 20,
                    color: '#DBEAFE',
                    fontWeight: 400,
                    marginBottom: 35,
                  }}
                >
                  Access your account to manage water services, view bills, and track consumption with ease.
                </p>

                <div className={classes.features}>
                  <div className={classes.feature}>
                    <img src={dot} alt="" />
                    <span>24/7 Account Access</span>
                  </div>
                  <div className={classes.feature}>
                    <img src={dot} alt="" />
                    <span>Real-time Bill Tracking</span>
                  </div>
                  <div className={classes.feature}>
                    <img src={dot} alt="" />
                    <span>Service Request Management</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default NewSignup;
